<!-- Trigger button to open ICD lookup dialog -->
<div class="hx-icd-lookup-trigger">
  <!-- Icon-only trigger button (buttonLabel removed) -->
  <button
    hxIconButton
    [svgIcon]="buttonIcon()"
    [iconSize]="iconSize()"
    [variant]="buttonVariant()"
    [context]="buttonContext()"
    [size]="buttonSize()"
    [rounded]="buttonRounded()"
    [disabled]="disabled()"
    [attr.aria-label]="buttonAriaLabel()"
    [hxTooltip]="buttonTooltip() ?? buttonAriaLabel()"
    title="Add ICD Codes"
    (click)="openPanel()"
    type="button"></button>
</div>

<!-- Side nav positioned absolutely relative to nearest positioned ancestor -->
@if (isPanelOpen()) {
  <div class="hx-icd-lookup__overlay" (click)="onOverlayClick($event)">
    <hx-side-nav
      class="hx-icd-lookup__side-nav"
      [mode]="'over'"
      [position]="'end'"
      [opened]="true"
      [showToggle]="false"
      [disableClose]="true"
      [autoFocus]="true">
      <div hx-header-content class="hx-icd-lookup__header">
        <span class="hx-icd-lookup__title-icon" aria-hidden="true">+</span>
        <h3 class="hx-icd-lookup__title">{{ title() }}</h3>
      </div>

      <div class="hx-icd-lookup__panel" [stopPropagation]="['click']">
        <div class="hx-icd-lookup__body">
          <hx-note
            class="hx-icd-lookup__note"
            context="info"
            appearance="outlined"
            description="Selected codes will be added to Assessment and Plan."></hx-note>
          @if (isPanelOpen()) {
            <hx-search-typeahead
              [items]="searchItems()"
              [placeholder]="placeholder()"
              panelClass="hx-icd-lookup-search-panel"
              [minChars]="0"
              [expandedCount]="'all'"
              [showTags]="true"
              [multiple]="true"
              [enableIncrementalLoading]="enableIncrementalLoading()"
              [hasMore]="hasMore()"
              [loadingMore]="loadingMore()"
              [pageSize]="pageSize()"
              (selectedItemsChanged)="onSelectedItemsChanged($event)"
              (itemsChanged)="onItemsChanged($event)"
              (searchChange)="searchChange.emit($event)"
              (loadMore)="loadMore.emit($event)"
              data-testid="icd-search-input"></hx-search-typeahead>
          }
        </div>

        <div class="hx-icd-lookup__actions">
          <button
            hxButton
            variant="outline"
            context="neutral"
            type="button"
            (click)="onCancel()"
            data-testid="cancel-button">
            Cancel
          </button>

          <button
            hxButton
            variant="fill"
            context="brand"
            type="button"
            [disabled]="!isAddButtonEnabled()"
            (click)="onAdd()"
            data-testid="add-button">
            Add
          </button>
        </div>
      </div>
    </hx-side-nav>
  </div>
}
